var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Navigation/chevron_right"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3879_169485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.513672,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3879_169485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron_right",
    d: "M9.16289 17.2508C8.94622 17.0341 8.83789 16.7841 8.83789 16.5008C8.83789 16.2174 8.94622 15.9674 9.16289 15.7508L12.9129 12.0008L9.16289 8.25078C8.94622 8.03411 8.83789 7.78411 8.83789 7.50078C8.83789 7.21745 8.94622 6.96745 9.16289 6.75078C9.37956 6.53411 9.62956 6.42578 9.91289 6.42578C10.1962 6.42578 10.4462 6.53411 10.6629 6.75078L15.1629 11.2508C15.2796 11.3674 15.3629 11.4883 15.4129 11.6133C15.4629 11.7383 15.4879 11.8674 15.4879 12.0008C15.4879 12.1341 15.4629 12.2633 15.4129 12.3883C15.3629 12.5133 15.2796 12.6341 15.1629 12.7508L10.6629 17.2508C10.4462 17.4674 10.1962 17.5758 9.91289 17.5758C9.62956 17.5758 9.37956 17.4674 9.16289 17.2508Z",
    fill: "#D3135A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.35038992b475684cd990afe98337ca5d.svg";
export { ForwardRef as ReactComponent };